import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ITestimony, ITestimonyToCreate } from '../shared/models/testimony';

@Injectable({
  providedIn: 'root'
})
export class TestimonyService {
   baseUrl:string = environment.apiUrl + 'Testimony';
 

  constructor(private http: HttpClient) { }

 
  addTestimony(testimony: any) {
    return this.http.post<any>(this.baseUrl, testimony);
  }
    
  addproduct(productRequest: ITestimony): Observable<ITestimony>  {
     const  addProductModel: ITestimonyToCreate = {
       fullName: productRequest.fullName,
       comment: productRequest.comment,
       star: productRequest.star,
      
     };
     return this.http.post<ITestimony>(this.baseUrl, addProductModel)
   }
 getTestimonies(): Observable<ITestimony[]> {
  return this.http.get<ITestimony[]>(this.baseUrl);
}
}
